export default "/images/tiutLogoW.png?df58f461cf15875705aeed65504b9936";